import { Styles } from "../../config"

let devBorder = ""
if (false) devBorder = "1px solid gray"

const styles = {
	border: devBorder,

	fontFamily: "inherit",
	color: Styles.Color.primary
}

export default styles
